import apiClient from './client';
import type { RateCard, RateCardRates, RateCardActivityLogEntry } from '../../types';

export const rateCardApi = {
  /** Get the current global rate card */
  get: async (): Promise<RateCard> => {
    return apiClient.get<RateCard>('/api/admin/rate-card');
  },

  /** Update rates on the global rate card (partial merge) */
  update: async (rates: Partial<RateCardRates>): Promise<RateCard> => {
    return apiClient.put<RateCard>('/api/admin/rate-card', { rates });
  },

  /** Get paginated activity log */
  getActivityLog: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<{
    data: RateCardActivityLogEntry[];
    pagination: { page: number; limit: number; total: number; totalPages: number };
  }> => {
    return apiClient.getPaginated<RateCardActivityLogEntry>(
      '/api/admin/rate-card/activity-log',
      params,
    );
  },
};

export default rateCardApi;
